var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.story && _vm.story.content)?_c('sb-render',{attrs:{"item":_vm.story.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }